// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-code .hljs {\n  display: block;\n  padding: 20px;\n  background-color: #f6f8fa;\n  font-size: 0.875rem;\n  border-radius: 12px;\n  box-sizing: border-box;\n  overflow-x: auto;\n}\n.tc-code + p,\n.tc-code + .tc-code {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
